// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.vrmodel.RentalManagerUserPropertyVrModelV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyVrModelAssociateListingResponseV2WebDto,
  UserPropertyVrModelAssociateListingV2RequestDto,
  UserPropertyVrModelAssociateModelResponseV2WebDto,
  UserPropertyVrModelAssociateModelV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing_Path =
  '/api/web/v2/users/properties/vrModel/associateListing';

/**
 * Associate / Disassociate a vrModel to listing
 */
export const RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing = (
  postData: UserPropertyVrModelAssociateListingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyVrModelAssociateListingV2RequestDto,
    UserPropertyVrModelAssociateListingResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel_Path =
  '/api/web/v2/users/properties/vrModel/associateModel';

/**
 * Associate / Disassociate a vrModel to a floor plan or unit
 */
export const RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel = (
  postData: UserPropertyVrModelAssociateModelV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyVrModelAssociateModelV2RequestDto,
    UserPropertyVrModelAssociateModelResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
